<template>
    <div class="contents">
        <input
            v-bind="$attrs"
            :id="props.id"
            v-model="proxyChecked"
            type="checkbox"
            :dusk="props.dusk"
            :value="props.value"
            :required="props.required"
            :class="[
                'block border-gray-300 rounded shadow-sm text-brand-600 focus:border-brand-300 focus:ring focus:ring-brand-200/50 forms__field_input--checkbox',
                sizeClass,
            ]"
        />
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps({
    modelValue: {
        type: [Boolean, Number, String],
        default: undefined,
    },
    checked: {
        type: [Boolean, Number, String],
        default: false,
    },
    value: {
        type: [Boolean, String, Number],
        default: null,
    },
    dusk: {
        type: String,
        default: null,
    },
    size: {
        type: String,
        default: 'base',
    },
    required: {
        type: Boolean,
        default: false,
    },
    id: {
        type: String,
        default: null,
    },
});

const emit = defineEmits(['update:modelValue', 'update:checked']);

const numberToBoolean = (input: number | boolean | string): boolean => {
    if (typeof input === 'boolean') {
        return input;
    }
    if (typeof input === 'string') {
        return input === '1';
    }
    return input === 1;
};

const proxyChecked = computed<boolean>({
    get() {
        const value = props.modelValue !== undefined ? props.modelValue : props.checked;
        return numberToBoolean(value);
    },
    set(val: boolean) {
        emit('update:modelValue', val);
        emit('update:checked', val);
    },
});

const sizeClass = computed(() => {
    const sizes: Record<string, string> = {
        xs: 'w-2.5 h-2.5',
        sm: 'w-3 h-3',
        base: 'w-4 h-4',
        lg: 'w-5 h-5',
        xl: 'w-6 h-6',
    };
    return sizes[props.size] ?? sizes.base;
});
</script>
